import React from "react";

export type MailTemplateVisualEditorProps = {
    placeholder?: string,
    disableBlocksEdit?: boolean,
    disablePreview?: boolean
}

export const MailTemplateVisualEditorContext = React.createContext<MailTemplateVisualEditorProps>({});
